import { defineStore } from 'pinia'
import helpers from "./storeHelpers";

export const usePointStore = defineStore('pointStore', {
    state: () => ({
        points: [],
        products: {
            Heading: "Select machines",
            List: []
        },
        categories: {
            Heading: "Select categories",
            List: []
        },
        selectedCategories: [],
        depths: {
            Heading: "Select depth range",
            List: []
        },
        search: {
            Heading: "Search results",
            Showing: "Showing",
            Results: "results",
            Match: "matching"
        },
        filter: {
            Clear: "Clear",
            FilterHeading: "Filter Heading",
            FilterText: "Filter Text"
        }

    }),
    
    getters: {
        searchResults: (state) => {
            var pointsNumber = 0;
            for (var i = 0; i < state.points.length; i++) {
                if (!state.points[i].Disabled) {
                    pointsNumber++;
                }
            }
            return pointsNumber;
        },

        selectedProducts: (state) => {
            var productArray = [];
            for (var i = 0; i < state.products.List.length; i++) {
                if (state.products.List[i].Selected) {
                    productArray.push(state.products.List[i]);
                }
            }
            return productArray;
        },
        selectedDepths: (state) => {
                var depthArray = [];
                for (var i = 0; i < state.depths.List.length; i++) {
                    if (state.depths.List[i].Selected) {
                        depthArray.push(state.depths.List[i]);
                    }
                }
                return depthArray;
        },
        selectedCategories: (state) => {
            var categoryArray = [];
            for (var i = 0; i < state.categories.List.length; i++) {
                if (state.categories.List[i].Selected) {
                    categoryArray.push(state.categories.List[i]);
                }
            }
            return categoryArray;
        },
        enabledPoints: (state) => {
            var pointArray = [];
            for (var i = 0; i < state.points.length; i++) {
                if (state.points[i].Disabled === false) {
                    pointArray.push(state.points[i]);
                }
            }
            return pointArray;
        },
        selectedPoint: (state) => {
            var pointNumber = 0;
            var pointArray = [];
            for (var i = 0; i < state.points.length; i++) {
                if (state.points[i].Selected) {
                    pointNumber++;
                    pointArray.push(state.points[i]);
                }
            }
            if (pointNumber === 1) {
                return pointArray[0];
            }
            else {
                return '';
            }
        }

    },
    actions: {
        setInitialState() {
            helpers.getPoints().then((data) => {
                this.points = data;
            }),
            helpers.getProducts().then((data) => {
                this.products = data;
            }),
            helpers.getCategories().then((data) => {
                this.categories = data;
            }),
            helpers.getDepths().then((data) => {
                this.depths = data;
                
            }),
            helpers.getSearch().then((data) => {
                this.search = data;
            }),
            helpers.getFilter().then((data) => {
                this.filter = data;
            })
        },
        toggleSelectedCategory(categoryId) { 
            this.categories.List.map((category) => {
                if (category.Id == categoryId){
                    category.Selected = !category.Selected;

                    this.disableProductByCategory(category);
                }
                
            });

            
            //this.filterPoint();
            
        },
        toggleSelectedFilter(object) {
            if (!object.Disabled) {
                object.Selected = !object.Selected;
            }
        },
        disableProductByCategory(category) {
            console.log(this.products.List);
           for (var i = 0; i < this.products.List.length; i++) {
               var productIndex = this.products.List[i].Categories.findIndex(x => x.Id === category.Id);
               if ((category.Selected && productIndex >= 0) ||
                   (!category.Selected && this.selectedCategories.length === 0 && this.selectedDepths.length === 0)) {
                   this.products.List[i].Disabled = false;
               }
               else {
                   this.products.List[i].Disabled = true;
                   for (var k = 0; k < this.selectedCategories.length; k++) {
                       productIndex = this.products.List[i].Categories.findIndex(x => x.Id === this.selectedCategories[k].Id);
                       if ( this.selectedCategories[j] !== category && productIndex >= 0) {
                           this.products.List[i].Disabled = false;
                           break;
                       }
                   }
                   if (this.products.List[i].Disabled === true) {
                       for (var j = 0; j < this.selectedDepths.length; j++) {
                           if (this.selectedDepths[j].MaxDepth <= this.products.List[i].MaxDepth) {
                               this.products.List[i].Disabled = false;
                               break;
                           }
                       }
                   }
               }
           }
        },
        toggleSelectedProduct(product) {
            this.disableDepth(product);
            this.disableCategory(product);
            this.filterPoint();
        },
        disableDepth(product) {
            var depthIndex = this.depths.List.findIndex(x => x.MaxDepth === parseInt(product.MaxDepth));
            if (product.Selected) {
                for (var i = 0; i < depthIndex + 1; i++) {
                    this.depths.List[i].Disabled = false;
                }
                for (var i = depthIndex + 1; i < this.depths.List.length; i++) {
                    this.depths.List[i].Disabled = true;
                    for (var j = 0; j < this.selectedProducts.length; j++) {
                        if (this.selectedProducts[j] !== product) {
                            if (this.selectedProducts[j].MaxDepth >= this.depths.List[i].MaxDepth) {
                                this.depths.List[i].Disabled = false;
                            }
                        }
                    }
                }
            }
            else {
                for (var i = depthIndex + 1; i < this.depths.List.length; i++) {
                    this.depths.List[i].Disabled = false;
                }
                for (var i = 0; i < this.depths.List.length; i++) {
                    for (var j = 0; j < this.selectedProducts.length; j++) {
                        if (this.selectedProducts[j].MaxDepth >= this.depths.List[i].MaxDepth) {
                            this.depths.List[i].Disabled = false;
                            break;
                        }
                        else {
                            this.depths.List[i].Disabled = true;
                        }
                    }
                }
            }
        },
        disableProductByDepth(depth) {
            for (var i = 0; i < this.products.List.length; i++) {
                if ((depth.Selected && depth.MaxDepth <= this.products.List[i].MaxDepth) ||
                    (!depth.Selected && this.selectedCategories.length === 0 && this.selectedDepths.length === 0)) {
                    this.products.List[i].Disabled = false;
                }
                else {
                    this.products.List[i].Disabled = true;
                    for (var j = 0; j < this.selectedDepths.length; j++) {
                        if (this.selectedDepths[j] !== depth && this.selectedDepths[j].MaxDepth <= this.products.List[i].MaxDepth) {
                            this.products.List[i].Disabled = false;
                            break;
                        }
                    }
                    if (this.products.List[i].Disabled === true) {
                        for (var k = 0; k < this.selectedCategories.length; k++) {
                            var productIndex = this.products.List[i].Categories.findIndex(x => x.Id === this.selectedCategories[k].Id);
                            if (productIndex >= 0) {
                                this.products.List[i].Disabled = false;
                                break;
                            }
                        }
                    }
                }
            }
         },
        disableCategory(product) {
            if (product.Selected) {
                for (var i = 0; i < this.categories.List.length; i++) {
                    var categoryIndex = product.Categories.findIndex(x => x.Id === this.categories.List[i].Id);
                    if (categoryIndex < 0) {
                        this.categories.List[i].Disabled = true;
                        for (var j = 0; j < this.selectedProducts.length; j++) {
                            if (this.selectedProducts[j] !== product) {
                                categoryIndex = this.selectedProducts[j].Categories.findIndex(x => x.Id === this.categories.List[i].Id);
                                if (categoryIndex >= 0) {
                                    this.categories.List[i].Disabled = false;
                                }
                            }
                        }
                    }
                    else {
                        this.categories.List[i].Disabled = false;
                    }
                }
            }
            else {
                for (var i = 0; i < this.categories.List.length; i++) {
                    var categoryIndex = product.Categories.findIndex(x => x.Id === this.categories.List[i].Id);
                    var categoryExists = 0;
                    if (categoryIndex < 0) {
                        this.categories.List[i].Disabled = false;
                    }
                    for (var j = 0; j < this.selectedProducts.length; j++) {
                        categoryIndex = this.selectedProducts[j].Categories.findIndex(x => x.Id === this.categories.List[i].Id);
                        if (categoryIndex < 0) {
                            categoryExists++;
                        }
                        else {
                            categoryExists = 0;
                            break;
                        }
                    }
                    if (categoryExists > 0) {
                        this.categories.List[i].Disabled = true;
                    }
                }
            }
        },
        filterPoint() { 
            //loop through points and check categories, depths and products and set disabled if one criterion doesn't match
            for (var i = 0; i < this.points.length; i++) {
                var pointDisabled = false;
                var selectedProductsNumber = 0;
                for (var j = 0; j < this.selectedProducts.length; j++) {
                    selectedProductsNumber++;
                    var productIndex = this.points[i].Products.findIndex(x => x.Id === this.selectedProducts[j].Id);
                    if (productIndex < 0) {
                        this.points[i].Disabled = true;
                        pointDisabled = true;
                    }
                    else {
                        this.points[i].Disabled = false;
                        pointDisabled = false;
                        break;
                    }
                }
                if (selectedProductsNumber === 0) {
                    this.points[i].Disabled = false;
                }
                if (pointDisabled === false) {
                    var selectedDepthsNumber = 0;
                    for (var j = 0; j < this.selectedDepths.length; j++) {
                        selectedDepthsNumber++;
                        if (this.selectedDepths[j].MaxDepth <= this.points[i].MaxDepth && this.selectedDepths[j].MaxDepth > this.points[i].MinDepth) {
                            this.points[i].Disabled = false;
                            pointDisabled = false;
                            break;
                        }
                        else {
                            this.points[i].Disabled = true;
                            pointDisabled = true;
                        }
                    }
                    if (selectedDepthsNumber === 0) {
                        this.points[i].Disabled = false;
                    }
                    if (pointDisabled === false) {
                        var selectedCategoriesNumber = 0;
                        for (var j = 0; j < this.selectedCategories.length; j++) {
                            selectedCategoriesNumber++;
                            var categoryIndex = this.points[i].Categories.findIndex(x => x.Id === this.selectedCategories[j].Id);
                            if (categoryIndex < 0) {
                                this.points[i].Disabled = true;
                                pointDisabled = true;
                            }
                            else {
                                this.points[i].Disabled = false;
                                pointDisabled = false;
                                break;
                            }
                        }
                        if (selectedCategoriesNumber === 0) {
                            this.points[i].Disabled = false;
                        }
                    }
                }
                if (pointDisabled && this.points[i].Selected) {
                    this.points[i].Selected = false;
                }
            }
            this.refreshGlider();
        },
        clearFilter() {
            for (var i = 0; i < this.categories.List.length; i++) {
                this.categories.List[i].Selected = false;
                this.categories.List[i].Disabled = false;
            }
            for (var i = 0; i < this.depths.List.length; i++) {
                this.depths.List[i].Selected = false;
                this.depths.List[i].Disabled = false;
            }
            for (var i = 0; i < this.products.List.length; i++) {
                this.products.List[i].Selected = false;
                this.products.List[i].Disabled = false;
            }
            for (var i = 0; i < this.points.length; i++) {
                this.points[i].Disabled = false;
            }
        },
        updateScroll() {
            var scrollArea = document.getElementById('scroll-area');
            var container = document.getElementsByClassName('tool-list-container')[0];
            var toolWidth = 0;
            setTimeout(function () {
                if (!!document.getElementsByClassName('tool-preview')[0]) {
                    toolWidth = document.getElementsByClassName('tool-preview')[0].offsetWidth;
                }
                if (scrollArea.scrollLeft < (toolWidth / 3)) {
                    container.classList.remove('show-left');
                }
                else {
                    container.classList.add('show-left');
                }
                if (scrollArea.scrollLeft + scrollArea.offsetWidth < scrollArea.scrollWidth - (toolWidth / 3)) {
                    container.classList.add('show-right');
                }
                else {
                    container.classList.remove('show-right');
                }
            }, 200);
            if (this.selectedPoint) {
                var pointOffset = document.getElementById(this.selectedPoint.ArticleNr).offsetLeft;
                if (pointOffset < scrollArea.scrollLeft - (toolWidth / 2) || pointOffset - scrollArea.scrollLeft + (toolWidth / 2) > scrollArea.offsetWidth) {
                    var pointIndex = this.points.findIndex(x => x.ArticleNr === this.selectedPoint.ArticleNr);;
                    this.points[pointIndex].Selected = false;
                }
            }
         },
         refreshGlider() {
            var glider = document.getElementsByClassName('glider-track')[0];
            var toolWidth = 0;
            if (!!document.getElementsByClassName('tool-preview')[0]) {
                toolWidth = document.getElementsByClassName('tool-preview')[0].offsetWidth;
            }
            glider.style.width = ((this.enabledPoints.length * toolWidth) + 1) + 'px';
            this.updateScroll();
         }
         
        

    }

});
